export const downloadBase64File = (contentType: string, base64Data: string, fileName: string): void => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
};

// Windows and macOS reject these in a filename, and a slash or control character in a
// lab or price list name would otherwise turn into a path segment in the download.
// Deliberately a blocklist: an ASCII allowlist would strip the å ä ö out of Nordic names.
const UNSAFE_FILE_NAME_CHARACTERS = /[/\\:*?"<>|\u0000-\u001f\u007f]/g;

const sanitizeFileNamePart = (value?: string): string =>
    (value ?? '').replace(UNSAFE_FILE_NAME_CHARACTERS, '').replace(/\s+/g, ' ').trim();

// [Lab name] - [price list or customer name] Pricelist.pdf, per DD-3320. Empty parts are
// dropped so a missing name cannot produce a leading ' - '.
export const buildPriceListPdfFileName = (labName?: string, priceListName?: string): string => {
    const nameParts = [sanitizeFileNamePart(labName), sanitizeFileNamePart(priceListName)].filter(Boolean);
    return nameParts.length ? `${nameParts.join(' - ')} Pricelist.pdf` : 'Pricelist.pdf';
};

export const handleDownload = (filename: string, fileData: Blob): void => {
    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(fileData);
    downloadLink.download = filename;
    downloadLink.target = '_blank';
    downloadLink.click();
};

export const downloadUrl = (filename: string, url: string): void => {
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = filename;
    if (filename.includes('.pdf') || filename.includes('.html')) {
        downloadLink.target = '_blank';
    }
    downloadLink.click();
};

export const handlePrint = (base64Data: string): void => {
    // check for if iframe already present, then remove it
    const previousIframe = document.getElementById('print_pdf');
    if (previousIframe) {
        previousIframe.remove();
    }
    const binary = atob(base64Data.replace(/\s/g, ''));
    const len = binary.length;
    const buffer = new ArrayBuffer(len);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
    }
    const blob = new Blob([view], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    iframe.id = 'print_pdf';
    document.body.appendChild(iframe);
    iframe.contentWindow?.print();
};
